import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatCommonModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMultiSortDirective } from '@dice/app/components/organisms/mat-multi-sort/mat-multi-sort.directive';
import { MatMultiSortHeaderComponent } from '@dice/app/components/organisms/mat-multi-sort/mat-multi-sort-header/mat-multi-sort-header.component';

@NgModule({
  declarations: [MatMultiSortHeaderComponent, MatMultiSortDirective],
  exports: [MatMultiSortHeaderComponent, MatMultiSortDirective],
  imports: [
    CommonModule,
    MatCommonModule,
    MatDividerModule,
    DragDropModule,
    MatIconModule,
    MatCheckboxModule,
    MatMenuModule,
    MatButtonModule,
    FormsModule,
    MatChipsModule,
    MatTooltipModule,
    MatDialogModule,
  ],
})
export class MatMultiSortModule {}
